import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Table, Loader, Popup} from 'semantic-ui-react';
import {monthShortDate} from '../../../common/constants/datesFormat';
import RemoveIcon from './removeIcon';

class Detail extends Component {
  renderSubstitute(element) {
    return element.partCode === element.substitute ? '' : element.substitute;
  }

  renderBody() {
    const {loading, orderDetail} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!orderDetail.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return orderDetail.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{moment(element.date).format(monthShortDate)}</Table.Cell>
          <Table.Cell>{element.partCode}</Table.Cell>
          <Table.Cell>{element.partName}</Table.Cell>
          <Table.Cell>{this.renderSubstitute(element)}</Table.Cell>
          <Table.Cell>{element.icc}</Table.Cell>
          <Table.Cell>{element.transport}</Table.Cell>
          <Table.Cell>{this.renderReason(element)}</Table.Cell>
          <Table.Cell>{element.orderRepair}</Table.Cell>
          <Table.Cell textAlign='right'>{element.partQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            <RemoveIcon element={element} index={index} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderReason(element) {
    return (
      <Popup
        inverted
        position='top center'
        content={element.reasonDescription}
        trigger={<span>{element.reason}</span>}
      />
    );
  }

  render() {
    return (
      <Card raised fluid>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Fecha</Table.HeaderCell>
              <Table.HeaderCell>Código</Table.HeaderCell>
              <Table.HeaderCell>Descripción</Table.HeaderCell>
              <Table.HeaderCell>Sustituto</Table.HeaderCell>
              <Table.HeaderCell>ICC</Table.HeaderCell>
              <Table.HeaderCell>Vía</Table.HeaderCell>
              <Table.HeaderCell>Razón</Table.HeaderCell>
              <Table.HeaderCell>Orden de Reparación</Table.HeaderCell>
              <Table.HeaderCell width='1'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.renderBody()}</Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dealerSpecialOrders.loading,
    'orderDetail': state.dealerSpecialOrders.list,
  };
};

export default connect(mapStateToProps)(Detail);
